import { instance } from './_config.js'

const getUrlZoho = async () => {
    try {
        const rs = await instance.get(`zoho_work_drive`)
        if (rs.data) {
            return rs.data
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const setZohoParams = async (params) => {
    try {
        const rs = await instance.post(`zoho_work_drive`, params)
        if (rs.data) {
            return rs.data
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const sreatBuckup = async () => {
    try {
        const rs = await instance.get(`zoho_work_drive/backup`)
        if (rs.data) {
            return rs.data
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

export { getUrlZoho, setZohoParams, sreatBuckup }